function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M80 50.18l-13.09 104h26.18L80 50.18zM60.95 34.8a30.46 30.46 0 000 43.12M43.34 19.4a52.21 52.21 0 000 73.93M25.73 4a74 74 0 000 104.73M99.05 34.8a30.46 30.46 0 010 43.12M116.66 19.4a52.21 52.21 0 010 73.93M134.27 4a74 74 0 010 104.73"
});

var SvgNetwork = function SvgNetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 158.18",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgNetwork;